import { render, staticRenderFns } from "./CertificateCell.vue?vue&type=template&id=6195148e"
import script from "./CertificateCell.vue?vue&type=script&lang=js"
export * from "./CertificateCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports